import { render, staticRenderFns } from "./ServiceDetailsSidebar.vue?vue&type=template&id=163cb510&"
import script from "./ServiceDetailsSidebar.vue?vue&type=script&lang=js&"
export * from "./ServiceDetailsSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports